import {Component, ElementRef, Inject, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {filter} from 'rxjs/operators';
import {CardDetails} from '../../../models/order';
import {OrderService} from '../../../order.service';
import {Router} from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-wallet-add-cardconnect',
  templateUrl: './wallet-add-cardconnect.component.html',
  styleUrls: ['./wallet-add-cardconnect.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WalletAddCardconnectComponent implements OnInit{
  iTokenUrl: any;
  phoneNumber:string;
  guestCheckout = false;
  storeId:string;
  paymentGateway: string;
  form:FormGroup;
  error: any
  @ViewChild("month",{static: true}) monthElement: ElementRef;
  @ViewChild("year",{static: true}) yearElement: ElementRef;
  @ViewChild("cvc",{static: true}) cvcElement: ElementRef;
  @ViewChild("nameOnCard",{static: true}) nameElement: ElementRef;

  constructor(private sanitizer:DomSanitizer,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef : MatDialogRef<WalletAddCardconnectComponent>,
              private fb: FormBuilder,
              private orderService: OrderService,
              private router: Router, private _snackBar: MatSnackBar){
    this.iTokenUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.iTokenUrl}/itoke/ajax-tokenizer.html?tokenizewheninactive=true&css=%0A%0Abody%7Bmargin%3A0px%3B%7D%20.error%7Bcolor%3A%20red%3B%7D%20input%7Bwidth%3A%2096%25%3B%20height%3A%2055px%3B%20border%3A%201px%20solid%20%23c1c1c1%3B%20border-radius%3A%205px%3B%20font-size%3A%2018px%3B%20padding%3A%200%205px%3B%7D%0A`);
    this.phoneNumber = this.data.phoneNumber;
    this.storeId = this.data.storeId;
    this.paymentGateway = this.data.paymentGateway;
    // ENG-5609: a guest has not proved the number is theirs, so their card is for this order only.
    // This path reaches payment/new_card, which saves whatever add_to_wallet says, and the box
    // defaults to ticked.
    this.guestCheckout = !!this.data.guestCheckout;

    // ENG-5908: only the card provider's frame may hand us a token; ignore anything else.
    const tokenOrigin = new URL(environment.iTokenUrl).origin;
    window.addEventListener('message', function (event) {
      if (event.origin !== tokenOrigin) { return; }
      let token;
      try { token = JSON.parse(event.data); } catch (e) { return; }
      if (!token || typeof token.message === 'undefined') { return; }
      localStorage.setItem('token', token.message)
    });
  }

  ngOnInit() {
    localStorage.setItem('token', null)
    const monthMaxLength = 2;
    const yearMaxLength = 2;
    const cvcMaxLength = 4;
    this.form = this.fb.group({
      month: ["", [Validators.required, Validators.maxLength(monthMaxLength)]],
      year: ["", [Validators.required, Validators.maxLength(yearMaxLength)]],
      cvc: ["", [Validators.required, Validators.maxLength(cvcMaxLength)]],
      nameOnCard: ["", [Validators.required]],
      addtoWallet: [{value: !this.guestCheckout, disabled: this.guestCheckout}]
    })

    this.form.get("month").valueChanges.pipe(filter((value: string) => value.length === monthMaxLength))
      .subscribe(() => this.yearElement.nativeElement.focus());

    this.form.get("year").valueChanges.pipe(filter((value: string) => value.length === yearMaxLength))
      .subscribe(() => this.cvcElement.nativeElement.focus());

    this.form.get("cvc").valueChanges.pipe(filter((value: string) => value.length === cvcMaxLength))
      .subscribe(() => this.nameElement.nativeElement.focus());
  }

  submit() {
    if (this.form.valid) {
      let phoneNumber = this.phoneNumber || localStorage.getItem('phoneNumber');
  
      this.orderService.addNewCard(
        this.storeId,
        phoneNumber,
        this.form.get("nameOnCard").value,
        this.form.get("month").value,
        this.form.get("year").value,
        this.form.get("cvc").value,
        localStorage.getItem('token'),
        this.guestCheckout ? false : this.form.get('addtoWallet').value
      ).subscribe(
        response => {
          this._snackBar.open('Payment method added', '', { duration: 3000, verticalPosition: 'top' });
          let cardDetail = Object.assign(new CardDetails(), response);
          this.dialogRef.close(cardDetail);
        },
        error => {
          this.error = error;
        }
      );
    }
  }

  dismiss(){
    this.dialogRef.close()
  }

  hasToken(){
    const token = localStorage.getItem('token');
    return token && token.length === 16 && this.form.valid;
  }
}
